<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <parametros-upload
          ref="parametrosUpload"
          @validation-change="formValid = $event"
        />
      </v-col>

      <v-col cols="12">
        <v-btn
          id="btn-salvar-montagem-ais-incremental"
          color="green"
          min-width="160"
          style="float: right;"
          :disabled="!formValid"
          :loading="loading"
          @click="agendar"
        >
          Agendar Processamento
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MontagensAisIncrementaisService from '@/services/MontagensAisIncrementaisService';

export default {
  name: 'MontagensAisIncrementaisUpload',

  components: {
    ParametrosUpload: () => import('@/components/montagensAisIncrementais/ParametrosUpload.vue')
  },

  data() {
    return {
      formValid: false,
      loading: false
    };
  },

  methods: {
    agendar() {
      this.loading = true;

      try {
        const data = this.$refs.parametrosUpload.exportData();

        MontagensAisIncrementaisService.salvar(data)
          .then(() => {
            this.$router.push({ name: 'Montagem AIS Incremental Histórico' });
            this.$toast.success('Execução agendada com sucesso. Acompanhe o processamento no histórico.', '', { position: 'topRight' });
          })
          .catch((error) => {
            const msg = error?.response?.data?.erro || error?.data?.erro || 'Erro ao agendar o Laudo Express.';
            this.$toast.error(msg, '', { position: 'topRight' });
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.message || 'Erro ao validar dados da execução.', '', { position: 'topRight' });
      }
    }
  }
};
</script>
